import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=8d77b37a&scoped=true&"
import script from "./_slug.vue?vue&type=script&lang=ts&"
export * from "./_slug.vue?vue&type=script&lang=ts&"
import style0 from "./_slug.vue?vue&type=style&index=0&id=8d77b37a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d77b37a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DiagramLikeBtn: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/diagram/DiagramLikeBtn.vue').default,DiagramForkBtn: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/diagram/DiagramForkBtn.vue').default,DiagramTags: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/diagram/DiagramTags.vue').default,CommonVideoPlayerDialog: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/common/CommonVideoPlayerDialog.vue').default,CommonParagraphsBlock: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/common/CommonParagraphsBlock.vue').default,AcquisitionFAQ: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/acquisition/AcquisitionFAQ.vue').default,CommonTextBlock: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/common/CommonTextBlock.vue').default,HomepageArticles: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/homepage/HomepageArticles.vue').default})
